export default (theme) => ({
  dashboardItem: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(1),
    flexGrow: 1,
  },
  dashboardGridItem: { padding: theme.spacing(1) },
  statusBadge: { margin: 5 },
  tagDivider: { margin: theme.spacing(1) },
  catagoryTitle: {
    margin: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  divider: { margin: theme.spacing(3) },
  tenantUserSelect: { width: '100%' },
});
